var map = {
	"./bg1.jpg": 514,
	"./bg2.jpg": 515,
	"./bg3.jpg": 516,
	"./bg4.jpg": 517,
	"./bg5.jpg": 518,
	"./bg6.jpg": 519,
	"./bg7.jpg": 520
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 884;


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg ^\.\/.*$
// module id = 884
// module chunks = 2